class CardCvcValidator {
  constructor(stripe) {
    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {};

    /**
     * Link
     * @param  {Object} scope
     * @param  {Object} element
     * @param  {Object} attrs
     * @param  {Array} requiredCtrls
     * @return {Void}
     */
    this.link = (scope, element, attrs, modelCtrl) => {
      modelCtrl.$validators.cardcvc = (modelValue) => {
        return Stripe.card.validateCVC(modelValue);
      };

    };
  }

  /**
   * Factory
   * @return {Object}
   */
  static directiveFactory() {
    CardCvcValidator.instance = new CardCvcValidator();
    return CardCvcValidator.instance;
  }
}

export default CardCvcValidator;



/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/cardCvcValidator.js
 **/